module.exports = __webpack_public_path__ + "img/grey_004.f201c411.png";